export default "__VITE_ASSET__IX$6o3ax__"